import React from 'react';
import { useQuery } from 'react-query';
import { useServiceClient } from 'common';
import { MyAppsEndPoints, MyAppsQueryKey } from './query-enums';

export const useGetAppLogoQuery = (appId: string) => {
    const { getData } = useServiceClient();
    const getAppLogo = React.useCallback(() => getData(`${MyAppsEndPoints.GET_APP_LOGO}/${appId}`)
        .then(response => response.blob())
        .then(imageBlob => URL.createObjectURL(imageBlob)), [appId, getData]);

    return useQuery(`${MyAppsQueryKey.GET_APP_LOGO}/${appId}`, getAppLogo);
};
